import { Routine } from 'redux-saga-routines';
import {
  fetchReferencesRoutine,
  fetchCandidateDataRoutine,
  updateRefStatusRoutine
} from '../../routines';
import { IReferenceScore } from '../../../../common/models/reference/IReferenceScore';
import { IProfileCandidate } from '../../../../common/models/candidate/IProfileCandidate';
import {
  updateCandidateOwnerRoutine,
  updateCandidateStatusRoutine
} from '../../../../containers/CandidatesBulkActions/routines';
import { find, map } from 'ramda';

export type ReferenceState = {
  items: IReferenceScore[];
  loading: boolean;
  loadingCandidateData: boolean;
  candidateData: IProfileCandidate | undefined;
};

const initialState: ReferenceState = {
  items: [],
  loading: true,
  candidateData: undefined,
  loadingCandidateData: true
};

export const references = (state: ReferenceState = initialState, { type, payload }: Routine<any>): ReferenceState => {
  switch (type) {
    case fetchReferencesRoutine.TRIGGER:
      return {
        ...state,
        loading: true
      };
    case fetchReferencesRoutine.SUCCESS:
      return {
        ...state,
        items: payload,
        loading: false
      };
    case fetchCandidateDataRoutine.TRIGGER:
      return {
        ...state,
        loadingCandidateData: true
      };
    case fetchCandidateDataRoutine.SUCCESS:
      return {
        ...state,
        candidateData: payload,
        loadingCandidateData: false
      };
    case fetchCandidateDataRoutine.FAILURE:
      return {
        ...state,
        loadingCandidateData: false
      };
    case fetchReferencesRoutine.FAILURE:
      return {
        ...state,
        loading: false
      };
    case updateCandidateOwnerRoutine.SUCCESS:
      return {
        ...state,
        candidateData: {
          ...(state.candidateData as IProfileCandidate),
          owner: payload.owner
        }
      };
    case updateCandidateStatusRoutine.SUCCESS:
      return {
        ...state,
        candidateData: {
          ...(state.candidateData as IProfileCandidate),
          status: payload.status
        }
      };
    case updateRefStatusRoutine.SUCCESS:
      return {
        ...state,
        items: map(ref => (find(id => id === ref.id, payload.ids as string[])
          ? { ...ref, status: payload.status }
          : ref), state.items)
      };
    default:
      return state;
  }
};
